import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DailyLogsService {

  overviewSummaries: BehaviorSubject<any> = new BehaviorSubject({
    reported: 0,
    recorded: 0,
    totalHours: 0
  });

  shouldReturn: Subject<any> = new Subject();
  changeTab: Subject<any> = new Subject();

  submissionError: Subject<any> = new Subject();

  constructor() { }

  setOverviewSummaries(summary) {
    this.overviewSummaries.next(summary);
  }

  shouldReturnToDailyLog() {
    this.shouldReturn.next(true);
  }

  notifyTabChange(tabName, params = {}) {
    this.changeTab.next({ slug: tabName , params});
  }
}
